var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-github",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.78 0H2.21C.99 0 0 .97 0 2.16v25.67C0 29.03.99 30 2.21 30h25.56c1.22 0 2.22-.97 2.22-2.16V2.16c0-1.2-1-2.16-2.22-2.16ZM8.9 25.56H4.45V11.24H8.9v14.32ZM6.67 9.29c-1.43 0-2.58-1.15-2.58-2.58s1.15-2.58 2.58-2.58 2.58 1.15 2.58 2.58S8.1 9.29 6.67 9.29Zm18.89 16.27h-4.45V18.6c0-1.66-.03-3.8-2.31-3.8s-2.67 1.81-2.67 3.68v7.08h-4.44V11.24h4.27v1.96h.06c.59-1.13 2.04-2.31 4.21-2.31 4.51 0 5.34 2.96 5.34 6.82v7.86Z",
    "data-name": "Social Media Icons"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b24f7d4a4ca8c937aede65a53397ed64.svg";
export { ForwardRef as ReactComponent };